/**
 * 菜单
 */
export default [
    {
        path: '/wage/payment',
        name: '账单',
        component: () => import ( /* webpackChunkName: "apvlProPayAdv" */ `@/views/wage/apvlPrc/paymentAdvice/index.vue`),
        meta: {
          permission: ['set_paymentnotice_approve']
        }
    },
    {
        path: '/finance/invoice',
        name: '发票',
        component: () => import ( /* webpackChunkName: "table" */ `@/views/finance/invoice/index.vue`),
        meta: {
          permission: ['set_paymentnotice_approve']
        }
    },
]
